// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2BWtA","productName":"Table_productName__3gm8m"};